import classNames from 'classnames';
import { CSSProperties, ChangeEvent } from 'react';
import styles from 'styles/components/common/forms/Checkbox.module.scss';

type TProps = {
  text: string;
  value?: string;
  inputId: string;
  formCheckboxStyle?: CSSProperties;
  labelStyle?: CSSProperties;
  checked?: boolean;
  disabled?: boolean;
  readOnly?: boolean;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
};

const Checkbox = ({
  text,
  value,
  inputId,
  formCheckboxStyle,
  labelStyle,
  checked,
  disabled,
  readOnly,
  onChange,
}: TProps) => {
  return (
    <div style={formCheckboxStyle} className="inline_flex">
      <div className={classNames(styles.checkbox_inline)}>
        <input
          id={inputId}
          type="checkbox"
          className={styles.checkbox}
          value={value}
          onChange={onChange}
          disabled={disabled || readOnly}
          checked={checked}
        />
        <label
          htmlFor={inputId}
          className={classNames(styles.label, {
            [styles.disabled_label]: disabled,
            [styles.readonly_label]: readOnly,
          })}
          style={labelStyle}
        >
          {text}
        </label>
      </div>
    </div>
  );
};

export default Checkbox;
